export const defaultStyles = [
    "firstName",
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "firstName",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "lastName",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "jobName",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "companyName",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "mobile",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "addressStreet",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "addressInfo",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "addressZipcode",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "addressCity",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "addressCountry",
    // },
    // {
    //     property: "color",
    //     value: "#000",
    //     type: "phone",
    // },
    // // FONT WEIGHT FOR EACH TXT
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "firstName",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "lastName",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "jobName",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "companyName",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "mobile",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "addressStreet",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "addressInfo",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "addressZipcode",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "addressCity",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "addressCountry",
    // },
    // {
    //     property: "fontWeight",
    //     value: "normal",
    //     type: "phone",
    // },
    // // TEXT DECORATION FOR EACH TXT
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "firstName",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "lastName",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "jobName",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "companyName",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "mobile",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "addressStreet",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "addressInfo",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "addressZipcode",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "addressCity",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "addressCountry",
    // },
    // {
    //     property: "textDecoration",
    //     value: "none",
    //     type: "phone",
    // },
    // // FONT STYLE FOR EACH TXT
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "firstName",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "lastName",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "jobName",
    // },
    // {
    //     property: "fontStyle",
    //     value: "none",
    //     type: "companyName",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "mobile",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "addressStreet",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "addressInfo",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "addressZipcode",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "addressCity",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "addressCountry",
    // },
    // {
    //     property: "fontStyle",
    //     value: "normal",
    //     type: "phone",
    // },
    // // FONT GENERAL STYLE
    // {
    //     property: "fontFamily",
    //     value: "Arial",
    //     type: "generalFontFamily",
    // },
    // {
    //     property: "fontSize",
    //     value: "12",
    //     type: "generalFontSize",
    // },
    // // DIV COLOR,
    // {
    //     property: "color",
    //     value: "#FFF",
    //     type: "divColor",
    // },
    // // Greetings
    // {
    //     property: "enabled",
    //     value: "false",
    //     type: "greetings",
    // },
    // {
    //     property: "padding",
    //     value: "12",
    //     type: "greetingsPadding",
    // },
    // // Event
    // {
    //     property: "enabled",
    //     value: "false",
    //     type: "event",
    // },
    // {
    //     property: "padding",
    //     value: "12",
    //     type: "eventPadding",
    // },
    // // Disclaimer
    // {
    //     property: "enabled",
    //     value: "false",
    //     type: "disclaimer",
    // },
    // {
    //     property: "padding",
    //     value: "12",
    //     type: "disclaimerPadding",
    // },
];
